<template>
  <!-- 账号密码截图 -->
  <div>
    <div class="page_win msgProtect" v-if="protect == '1'">
      <div class="head"><span>个人信息保护指引</span></div>
      <div class="msg">
        <span
          >欢迎下载游戏，我们非常重视个人信息和隐私保护。请在使用我们的服务前，详细阅读并同意</span
        >
        <a class="textColor" :href="platformInfo.userUrl">《用户协议》</a>
        <span>和</span>
        <a class="textColor" :href="platformInfo.policyUrl">《隐私政策》</a>
      </div>
      <div class="msg">

        <!-- <span>为了提供完整的游戏体验，我们会向您申请必要的权限和信息。您可选择同意或拒绝权限申请，如果拒绝可能会导致部分游戏体验异常。权限和信息包括：</span> -->

       <span>为了提供完整的游戏体验，我们会向您申请必要的权限和信息。您可选择同意或拒绝权限申请，如果拒绝可能会导致部分游戏体验异常。</span>

      </div>
      <!-- <div class="msg msg1">
        <span>存储权限：实现账号，图片的缓存和使用，图片保存与分享</span>
        <span>设备信息：读取设备唯一标识用于保护账号安全</span>
      </div> -->
      <div class="botBox">
        <div class="btnL" @click="unConsentProtect('2')">
          <span>不同意</span>
        </div>
        <div class="btnR" @click="consentProtect"><span>同意</span></div>
      </div>
    </div>
    <div class="page_win msgProtect" v-else-if="protect == '2'">
      <div class="head"><span>温馨指示</span></div>
      <div class="msg">
        <span>不授权同意</span>
        <!-- <span class="textColor">《用户协议》</span
        ><span>和</span>
        <span class="textColor">《隐私政策》</span> -->
        <a class="textColor" :href="platformInfo.userUrl">《用户协议》</a>
        <span>和</span>
        <a class="textColor" :href="platformInfo.policyUrl">《隐私政策》</a>


        <span>将无法进行游戏</span>
      </div>
      <div class="msg">
        <span>是否确认</span><span class="textColor" @click="unConsentProtect('1')">取消授权并退出游戏</span>
      </div>
      <div class="botBox">
        <div class="btnL" @click="unConsentProtect('1')">
          <span>取消授权</span>
        </div>
        <div class="btnR" @click="unConsentProtect('1')"><span>我再想想</span></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["", ""],
  inject: ["reload"],
  data() {
    return {
      adid:null,
      closeImg: require("../../assets/img/view10/close.png"), // 关闭
      protect: "1",
      platformInfo:{},
    };
  },
  creater() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.adid = localStorage.getItem("adid");
    this.platformInit();
  },
  methods: {
    platformInit(){
      let data = {
        platformId: 100,
        adId: this.adid
      };
      let _that = this;
      this.$http
        .post("https://platform-api.flyouxi.cn/platform-api/init", data)
        .then((res) => {
          if (res.body.code === 200) {
            if (res.body.data != null) {
              _that.platformInfo = res.body.data;
            }
          }
        });


    },

    // 关闭当前窗口
    closeWin: function () {
      //   this.$store.dispatch("IsAccountAndPasFun", false);
    },
    unConsentProtect(type) {
      this.protect = type;
    },
    consentProtect() {
      localStorage.setItem("userMsgProtect", "1");
      this.$store.dispatch("IsUserMsgProtectFun", false);
      this.reload();
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.head {
  @include flex_box(row, center, center);
  height: 0.5rem;
  margin-bottom: 0.1rem;
  color: #12CDB0;
  font-size: 16px;
  font-weight: bold;
}
.msg {
  color: #000000;
  font-size: 12px;
  margin-bottom: 0.26rem;
  span {
    line-height: 0.3rem;
    font-weight: bold;
  }
}
.msg1 {
  color: #878787;
  @include flex_box(column, none, none);
}
.textColor {
  color: #12CDB0;
}
.botBox {
  @include flex_box(row, space-between, stretch);
}
.btnL,
.btnR {
  flex: 1;
  height: 0.8rem;
  background-color: #12CDB0;
  color: #fff;
  @include flex_box(row, center, center);
  span {
    letter-spacing: 2px;
  }
}
.btnL {
  margin-right: 0.3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/view10/userMsgProtect.vue